import React from "react";
import styles from "./Button.module.css";

export const Button = ( {onClick, enabled=true, className, children} ) => {
    return (
        <div className={`${styles.buttonContainerDefault} ${className}`}
             onClick={ () => enabled && onClick()}
             data-state={enabled ? '' : 'disabled'}>
            {children}
        </div>
    );
}